<template>
  <div
    class="tw-relative tw-w-full tw-h-full tw-pb-4 tw-px-4 md:tw-px-0 md:tw-h-screen tw-bg-no-repeat tw-bg-cover tw-bg-monster-section tw-overflow-hidden"
  >
    <img class="tw-absolute" :src="`${imgPath}/animation-light-effect1.png`" />
    <div
      class="tw-w-full tw-hidden md:tw-block xl:tw-h-2/10 md:tw-h-1.2/10"
    ></div>
    <!-- <div class="tw-absolute tw-top-0 tw-w-full tw-h-32 tw-bg-white"></div> -->
    <div
      class="tw-relative tw-w-full tw-mt-9 md:tw-absolute md:tw-left-0 md:tw-top-0 md:tw-w-2/12 md:tw-h-full"
    >
      <div class="xl:tw-h-1/6 lg:tw-h-2.5/10  tw-flex tw-items-end">
        <section-tag tag-name="normal monster" :tag-number="slidePage" />
      </div>
    </div>
    <!-- desktop, tablet -->
    <div
      class="monster-carousel tw-block tw-w-0 tw-min-w-full tw-h-full"
      v-if="!mobile"
    >
      <VueSlickCarousel v-bind="settings" @beforeChange="beforeChangeCarousel">
        <div v-for="(monster, index) in monsterData" :key="index">
          <div
            v-animate="{ value: 'fadeInUp', delay: 300 }"
            class="tw-flex tw-flex-col tw-w-full tw-h-full tw-items-center tw-justify-center"
          >
            <img
              :src="`${imgPath}${monster.imgUrl}`"
              class="xl:tw-w-max lg:tw-w-2/4"
            />
            <span
              v-animate="{ value: 'fadeInUp', delay: 600 }"
              class="xl:tw-text-8xl lg:tw-text-7.5xl tw-font-caslon tw-text-white tw-uppercase"
              v-html="monster.name"
            ></span>
            <p
              v-animate="{ value: 'fadeInUp', delay: 900 }"
              class="tw-text-white tw-font-medium xl:tw-text-4xl lg:tw-text-3xl xl:tw-max-w-6xl lg:tw-max-w-5xl tw-text-center xl:tw-mt-10 lg:tw-mt-5"
              v-html="monster.desc"
            ></p>
          </div>
        </div>
        <template #customPaging="page">
          <div
            v-animate="{ value: 'fadeInUp', delay: 1200 }"
            class="dots-wrapper tw-relative custom-dot tw-w-28 tw-h-28 tw-box-content"
          >
            <div
              class="slick-dots-active tw-w-28 tw-h-28 tw-rounded-full tw-absolute inset-center tw-z-10"
            ></div>
            <img
              class="absolute tw-w-28 tw-h-28 inset-center"
              :src="`${imgPath}${monsterPaging[page].imgUrl}`"
            />
          </div>
        </template>
      </VueSlickCarousel>
    </div>
    <!-- mobile -->
    <div
      class="monster-carousel tw-block tw-w-0 tw-min-w-full tw-h-full tw-mt-6"
      v-if="mobile"
    >
      <VueSlickCarousel v-bind="settings" @beforeChange="beforeChangeCarousel">
        <div v-for="(monster, index) in monsterData" :key="index">
          <div
            class="tw-flex tw-flex-col tw-w-full tw-h-full tw-items-center tw-justify-center"
          >
            <img :src="`${imgPath}${monster.imgUrl}`" class="tw-px-4" />
            <span
              class="tw-text-4.4 tw-font-caslon tw-text-white tw-uppercase"
              v-html="monster.name"
            ></span>
            <p
              class="tw-text-white tw-text-center tw-text-1.4 tw-max-w-lg tw-font-medium"
              v-html="monster.desc"
            ></p>
          </div>
        </div>
        <template #customPaging="page">
          <div
            class="dots-wrapper tw-relative custom-dot tw-w-20 tw-h-20 tw-box-content"
          >
            <div
              class="slick-dots-active tw-w-20 tw-h-20 tw-rounded-full tw-absolute inset-center tw-z-10"
            ></div>
            <img
              class="absolute tw-w-20 tw-h-20 inset-center"
              :src="`${imgPath}${monsterPaging[page].imgUrl}`"
            />
          </div>
        </template>
      </VueSlickCarousel>
      <div class="tw-w-full tw-h-72"></div>
    </div>
  </div>
</template>

<script>
import SectionTag from "../components/SectionTag";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "monster-section",
  components: {
    VueSlickCarousel,
    SectionTag
  },
  props: {
    mobile: Boolean
  },
  data: function() {
    return {
      slidePage: "01",
      settings: {
        dots: true,
        arrows: false,
        fade: true,
        autoplay: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              autoplay: false,
              fade: false
            }
          }
        ]
      },
      imgPath: process.env.VUE_APP_IMG_URL,
      monsterData: [
        {
          imgUrl: "/nm01.png",
          name: "Algaea",
          desc:
            "Giant lizards that live near the Void Star. In the past, they used to be gentle enough to be a pet, but now they seem to attack and eat everything that moves."
        },
        {
          imgUrl: "/nm02.png",
          name: "PONOS",
          desc:
            "Miners who work hard to mine ores. Due to the curse of the Deimos, they cannot die and are forced to mine for eternity."
        },
        {
          imgUrl: "/nm03.png",
          name: "LIMOS",
          desc:
            "Spirits that followed Rete during the ancient times. They are still following Rete but for a different purpose. They are being used like pawns to bait out enemies."
        },
        {
          imgUrl: "/nm04.png",
          name: "DYSNOMIA",
          desc:
            "Little demons who have been hiding near the Zisk Plains for a long time. They are now working for Deimos cult who gave them some powers."
        },
        {
          imgUrl: "/nm05.png",
          name: "MAKAI",
          desc:
            "Fanatics who are obsessed with war and are followers of the Deimos cult. They went into the Zisk Plains where no one is present and began to wander."
        },
        {
          imgUrl: "/nm06.png",
          name: "HORKOS",
          desc:
            "They are ghosts of loyal knights who served the people of the Zisk Plains. They have been told they were massacred by the Deimos cultists. However, from some point on, they seemed to be wandering around the Zisk Plains looking for something."
        },
        {
          imgUrl: "/nm07.png",
          name: "AERGIA",
          desc:
            "Spirits trapped somewhere after being punished by Gaia for their lazy habits. After resentment against Gaia, they tried to destroy all followers of the divine. Eventually, they decided to live for the one who saved them, and came to the Zisk Plains."
        }
      ],
      monsterPaging: [
        {
          imgUrl: "/nmonster-icon-01.png"
        },
        {
          imgUrl: "/nmonster-icon-02.png"
        },
        {
          imgUrl: "/nmonster-icon-03.png"
        },
        {
          imgUrl: "/nmonster-icon-04.png"
        },
        {
          imgUrl: "/nmonster-icon-05.png"
        },
        {
          imgUrl: "/nmonster-icon-06.png"
        },
        {
          imgUrl: "/nmonster-icon-07.png"
        }
      ]
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      //console.log(newIndex);
      let number = newIndex + 1;
      this.slidePage = `0${number}`;
    }
  }
};
</script>

<style lang="postcss" scoped>
.monster-carousel >>> .slick-dots {
  @apply tw-w-full tw-max-w-lg tw-flex tw-flex-row tw-left-0 tw-right-0 tw--bottom-56 md:tw-max-w-full md:tw--bottom-44 tw-m-auto;
}
.monster-carousel >>> .slick-dots li {
  @apply tw-w-20 tw-h-20 md:tw-w-28 md:tw-h-28 tw-mt-3;
}
.monster-carousel >>> .slick-dots li .dots-wrapper .slick-dots-active {
  @apply tw-bg-black tw-bg-opacity-75;
}
.monster-carousel
  >>> .slick-dots
  .slick-active
  .dots-wrapper
  .slick-dots-active {
  @apply tw-bg-opacity-0 tw-bg-transparent tw-shadow-dots-active;
}
</style>
